module.exports = __webpack_public_path__ + "static/12-formation-deformation-s-viii-a263f18c3925fcd8e88f2ef8ea871eec.jpg";